/******/ (() => { // webpackBootstrap
    var __webpack_exports__ = {};
    Shopify.theme.jsGiftGuideSlider = {
        init: function ($section) {
            const $ggSlider = $section.find('.gift-guide--slider-column2');
            var isDesktop = window.innerWidth >= 768;

            if ($ggSlider.hasClass("right") && isDesktop) {
                var index = $ggSlider.attr('data-size')
            } else {
                var index = 0;
            }
            console.log("init", index);
            $ggSlider.flickity({
                initialIndex: index,
                contain: true,
                pageDots: false,
                imagesLoaded: true,
                groupCells: true,
                arrowShape: arrowShape,
            });
            // Resize flickity when the slider is settled
            $ggSlider.on('settle.flickity', function () {
                $ggSlider.flickity('resize');
            });

        },

        unload: function ($section) {
            const $slider = $section.find('.flickity-enabled');
            $slider.flickity('destroy');

        }
    }

    /******/
})()
    ;